import React, { forwardRef } from 'react';
import Style from '../../Styles/DashboardStyle.module.css';

const FileUpload = forwardRef(({ avatarURL, onFileChange }, ref) => (
    <div className={Style.newAccount}>
        <p>Upload Logo</p>
        <figure>
            {/* <div>
            <img src={avatarURL} alt="Company Logo" />
            </div> */}
            <input type="file" id="file" name="CompanyLogo" className={Style.CompanyLogo} ref={ref} onChange={onFileChange} />
        </figure>
        <span className={`${Style.fieldValidationValid} ${Style.textDanger}`} data-valmsg-for="CompanyLogo" data-valmsg-replace="true"></span>
    </div>
));

export default FileUpload;
